module.exports = __webpack_public_path__ + "img/new-post.bcf99e58.png";